import { actionTypes } from '../actions/actionTypes'

export default function locale(state = {}, action) {
  switch (action.type) {
    case actionTypes.SET_LOCALE_IN_USE:
      return { localeInUse: action.payload.localeInUse }

    default:
      return state
  }
}
